export enum SlotCategory {
  dinner = 'DINNER',
  lunch = 'LUNCH',
}
